export default "__VITE_ASSET__Ch$vIZVw__"